import React from 'react';
import { motion } from 'framer-motion';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BonusCard } from '../components/BonusCard';
import { CTAButton } from '../components/CTAButton';
import { CountdownTimer } from '../components/CountdownTimer';
import { PurchasePopup } from '../components/PurchasePopup';
import { UrgencyBanner } from '../components/UrgencyBanner';
import { TestimonialCard } from '../components/TestimonialCard';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { PlanSelector } from '../components/PlanSelector';
import { Quote, Users, Sparkles, CheckCircle, Clock, Target, TrendingUp, Gift, Zap, MessageCircle } from 'lucide-react';
export function LandingPage() {
  const bonuses = [{
    title: 'Efemérides Argentinas',
    description: 'Material específico para trabajar las principales fechas patrias y efemérides escolares en Nivel Inicial. Incluye recursos y propuestas organizadas para abordar cada fecha dentro del aula de forma clara y ordenada.',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/xirY2sC8T246NNhKPASfgi/WhatsApp_Image_2026-01-14_at_03.22.59.jpg'
  }, {
    title: 'Moldes para Goma Eva ✂️',
    description: 'Colección ampliada de moldes listos para imprimir y utilizar. Incluye carteleras, animales, personajes, títeres, letras, números y recursos decorativos pensados para el trabajo cotidiano en salas.',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/aH5WKxysy9cgYLyGPcLitQ/ChatGPT_Image_14_ene_2026,_02_26_57.png'
  }, {
    title: 'Audiocuentos Infantiles 🎧',
    description: 'Selección de audiocuentos infantiles en formato digital. Un recurso complementario ideal para actividades de escucha, momentos de relajación, rutinas diarias y momentos de lectura.',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/9ufftsduoaev6fdx5MEotb/bonus_3.jpg'
  }, {
    title: 'Cuentos Infantiles Imprimibles 📖',
    description: 'Cuentos infantiles en formato imprimible. Pensados para acompañar propuestas de lectura, proyectos literarios y actividades habituales del Nivel Inicial.',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/fF2JS8cT2USKxFnziNBqtQ/bonus_4.jpg'
  }];
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-162">
      <UrgencyBanner data-id="element-163" />
      <WhatsAppButton data-id="element-164" />
      <PurchasePopup data-id="element-165" />
      <div className="pt-8 md:pt-10" data-id="element-166">
        <HeroSection data-id="element-167" />
      </div>
      <ProblemSection data-id="element-168" />
      <SolutionSection data-id="element-169" />

      {/* Strong Value Proposition Section */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-orange-50 via-yellow-50 to-pink-50 relative overflow-hidden" data-id="element-170">
        <div className="absolute top-0 left-0 w-full h-full opacity-30" data-id="element-171">
          <div className="hidden md:block absolute top-20 left-10 w-32 h-32 bg-yellow-300 rounded-full blur-3xl" data-id="element-172"></div>
          <div className="hidden md:block absolute bottom-20 right-10 w-40 h-40 bg-pink-300 rounded-full blur-3xl" data-id="element-173"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-174">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-5xl mx-auto" data-id="element-175">
            <div className="text-center mb-10 md:mb-12" data-id="element-176">
              <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-slate-900 mb-4 md:mb-6 leading-tight" data-id="element-177">
                ¿Por qué elegir este Mega Pack?
              </h2>
              <p className="text-lg md:text-xl text-slate-700 font-medium" data-id="element-178">
                Porque no es solo un producto. Es tu{' '}
                <span className="text-orange-600 font-bold" data-id="element-179">
                  sistema de respaldo profesional
                </span>{' '}
                para todo el año.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-12" data-id="element-180">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} className="bg-white p-6 rounded-2xl shadow-lg border-2 border-orange-200" data-id="element-181">
                <div className="flex items-start gap-4" data-id="element-182">
                  <div className="bg-orange-100 p-3 rounded-full flex-shrink-0" data-id="element-183">
                    <Clock className="w-6 h-6 text-orange-600" data-id="element-184" />
                  </div>
                  <div data-id="element-185">
                    <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-186">
                      Ahorrá cientos de horas
                    </h3>
                    <p className="text-slate-600" data-id="element-187">
                      Dejá de perder domingos enteros buscando en Pinterest.
                      Todo está listo, organizado y probado por docentes reales.
                    </p>
                  </div>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="bg-white p-6 rounded-2xl shadow-lg border-2 border-pink-200" data-id="element-188">
                <div className="flex items-start gap-4" data-id="element-189">
                  <div className="bg-pink-100 p-3 rounded-full flex-shrink-0" data-id="element-190">
                    <Target className="w-6 h-6 text-pink-600" data-id="element-191" />
                  </div>
                  <div data-id="element-192">
                    <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-193">
                      Llegá preparada siempre
                    </h3>
                    <p className="text-slate-600" data-id="element-194">
                      Nunca más ese nudo en el estómago del domingo. Tenés un
                      banco de +250 ideas listas para aplicar cuando las
                      necesites.
                    </p>
                  </div>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} className="bg-white p-6 rounded-2xl shadow-lg border-2 border-purple-200" data-id="element-195">
                <div className="flex items-start gap-4" data-id="element-196">
                  <div className="bg-purple-100 p-3 rounded-full flex-shrink-0" data-id="element-197">
                    <CheckCircle className="w-6 h-6 text-purple-600" data-id="element-198" />
                  </div>
                  <div data-id="element-199">
                    <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-200">
                      Calidad garantizada
                    </h3>
                    <p className="text-slate-600" data-id="element-201">
                      Creado por docentes de Nivel Inicial que entienden tu
                      realidad. No es teoría, es lo que funciona en el aula.
                    </p>
                  </div>
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.4
            }} className="bg-white p-6 rounded-2xl shadow-lg border-2 border-green-200" data-id="element-202">
                <div className="flex items-start gap-4" data-id="element-203">
                  <div className="bg-green-100 p-3 rounded-full flex-shrink-0" data-id="element-204">
                    <TrendingUp className="w-6 h-6 text-green-600" data-id="element-205" />
                  </div>
                  <div data-id="element-206">
                    <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-207">
                      Recuperá tu energía
                    </h3>
                    <p className="text-slate-600" data-id="element-208">
                      Dejá de llegar agotada a tu casa. Cuando planificás
                      rápido, te queda tiempo para vos y tu familia.
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.5
          }} className="bg-gradient-to-r from-yellow-400 to-orange-400 p-6 md:p-8 rounded-2xl md:rounded-3xl text-center shadow-xl md:shadow-2xl" data-id="element-209">
              <p className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 md:mb-4 leading-tight" data-id="element-210">
                "Este pack vale más que meses de suscripciones y cursos que no
                usás"
              </p>
              <p className="text-base md:text-lg text-yellow-50" data-id="element-211">
                Una inversión única que te acompaña todo el año lectivo (y los
                que vienen)
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Origin Story Section */}
      <section className="py-12 md:py-20 bg-yellow-50 relative overflow-hidden" data-id="element-212">
        <div className="hidden md:block absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 bg-yellow-200 rounded-full opacity-30 blur-3xl" data-id="element-213"></div>
        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-214">
          <div className="max-w-3xl mx-auto" data-id="element-215">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white p-6 sm:p-8 md:p-12 rounded-2xl md:rounded-3xl shadow-xl border border-yellow-100" data-id="element-216">
              <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left gap-4 mb-6" data-id="element-217">
                <div className="bg-yellow-100 p-3 rounded-full flex-shrink-0" data-id="element-218">
                  <Users className="w-6 h-6 text-yellow-600" data-id="element-219" />
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-1" data-id="element-220">
                  Cómo nació este pack
                </h2>
              </div>

              <div className="prose prose-base md:prose-lg text-slate-600 mx-auto" data-id="element-221">
                <p className="mb-4" data-id="element-222">
                  Este pack no nació de una idea de marketing.{' '}
                  <strong data-id="element-223">Nació de una necesidad real.</strong>
                </p>
                <p className="mb-4" data-id="element-224">
                  De docentes que vivieron lo mismo que vos: llegar cansadas,
                  tener poco tiempo, pasar horas buscando ideas y sentir esa
                  presión constante por cumplir.
                </p>
                <p className="mb-6" data-id="element-225">
                  Hasta que un día alguien dijo:{' '}
                  <em data-id="element-226">
                    "¿Y si armamos todo junto, bien hecho, y dejamos de sufrir?"
                  </em>
                </p>
                <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400 italic text-slate-700" data-id="element-227">
                  "Ese fue el punto de quiebre. No para vender... Sino para
                  vivir mejor la docencia."
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-10 md:py-16 bg-white" data-id="element-228">
        <div className="container mx-auto px-4 md:px-6" data-id="element-229">
          <div className="text-center mb-8 md:mb-10" data-id="element-230">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="inline-flex items-center gap-2 mb-4 bg-gradient-to-r from-red-500 to-pink-500 text-white px-4 py-2 rounded-full shadow-md" data-id="element-231">
              <Gift className="w-4 h-4 flex-shrink-0" data-id="element-232" />
              <span className="text-xs sm:text-sm font-bold tracking-tight" data-id="element-233">
                ¡GRATIS SOLO POR HOY!
              </span>
            </motion.div>

            <motion.h2 initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-xl sm:text-2xl md:text-4xl font-bold text-slate-900 mb-2" data-id="element-234">
              4 Bonus Increíbles
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="text-sm md:text-base text-slate-600" data-id="element-235">
              Para complementar tu trabajo en la sala
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-5xl mx-auto" data-id="element-236">
            {bonuses.map((bonus, index) => <BonusCard key={index} number={index + 1} title={bonus.title} description={bonus.description} imageUrl={bonus.imageUrl} delay={index * 0.1} data-id="element-237" />)}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-12 md:py-20 bg-gradient-to-b from-slate-50 to-white relative overflow-hidden" data-id="element-238">
        <div className="absolute top-0 left-0 w-full h-full opacity-20" data-id="element-239">
          <div className="hidden md:block absolute top-10 right-10 w-64 h-64 bg-yellow-300 rounded-full blur-3xl" data-id="element-240"></div>
          <div className="hidden md:block absolute bottom-10 left-10 w-64 h-64 bg-pink-300 rounded-full blur-3xl" data-id="element-241"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-242">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-4xl mx-auto" data-id="element-243">
            <div className="text-center mb-8 md:mb-12" data-id="element-244">
              <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-3 md:mb-4" data-id="element-245">
                Acceso al Mega Pack
              </h2>
              <p className="text-lg md:text-xl text-slate-600" data-id="element-246">
                Inversión única. Recursos para todo el año.
              </p>
            </div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-white rounded-2xl md:rounded-3xl shadow-xl md:shadow-2xl border-2 md:border-4 border-yellow-400 overflow-hidden" data-id="element-247">
              <div className="bg-gradient-to-r from-yellow-400 to-orange-400 text-white text-center py-3 md:py-4 px-2" data-id="element-248">
                <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 mb-2" data-id="element-249">
                  <div className="flex items-center gap-2" data-id="element-250">
                    <Zap className="w-4 h-4 md:w-5 md:h-5" data-id="element-251" />
                    <span className="font-bold text-sm sm:text-base md:text-lg" data-id="element-252">
                      OFERTA ESPECIAL DE LANZAMIENTO
                    </span>
                    <Zap className="w-4 h-4 md:w-5 md:h-5" data-id="element-253" />
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-xs sm:text-sm" data-id="element-254">
                  <div className="flex items-center gap-1" data-id="element-255">
                    <Clock className="w-3 h-3 sm:w-4 sm:h-4" data-id="element-256" />
                    <span data-id="element-257">Esta oferta finaliza en:</span>
                  </div>
                  <div className="scale-90 sm:scale-100 origin-center" data-id="element-258">
                    <CountdownTimer data-id="element-259" />
                  </div>
                </div>
              </div>

              <div className="p-5 sm:p-8 md:p-10" data-id="element-260">
                <PlanSelector data-id="element-261" />

                <div className="bg-green-50 border border-green-200 rounded-xl md:rounded-2xl p-4 md:p-6 my-6 md:my-8" data-id="element-262">
                  <h3 className="font-bold text-slate-900 text-base md:text-xl mb-3 md:mb-4 flex items-center gap-2" data-id="element-263">
                    <CheckCircle className="w-5 h-5 md:w-6 md:h-6 text-green-600 flex-shrink-0" data-id="element-264" />
                    Lo que incluye tu inversión:
                  </h3>
                  <ul className="space-y-2 md:space-y-3" data-id="element-265">
                    {['Mega Pack completo (+250 recursos listos para usar)', '4 BONUS exclusivos que te ahorran horas de planificación', 'KIT DE GESTIÓN DOCENTE (tu sistema completo de organización)', 'Informes evaluativos listos para copiar y pegar', 'Guiones para reuniones con familias (sin improvisar nunca más)', 'Registro y seguimiento por alumno (todo ordenado)', 'Modelos de comunicaciones institucionales profesionales', 'Checklist mensual para tener TODO bajo control'].map((item, idx) => <li key={idx} className="flex items-start gap-2 md:gap-3" data-id="element-266">
                        <CheckCircle className="w-4 h-4 md:w-5 md:h-5 text-green-600 flex-shrink-0 mt-0.5 md:mt-1" data-id="element-267" />
                        <span className="text-slate-700 text-sm md:text-base leading-snug" data-id="element-268">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                <div className="text-center" data-id="element-269">
                  <p className="text-slate-600 text-sm md:text-base mb-4" data-id="element-270">
                    Pago único • Acceso inmediato • Sin suscripciones
                  </p>

                  <div className="mt-6 space-y-3" data-id="element-271">
                    <div className="flex items-center justify-center gap-2 text-slate-700" data-id="element-272">
                      <MessageCircle className="w-5 h-5 text-green-500" data-id="element-273" />
                      <p className="text-sm font-medium" data-id="element-274">
                        💬 ¿Tuviste algún problema con el pago o con el acceso?
                      </p>
                    </div>
                    <a href="https://wa.link/w7hdgn" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-green-600 hover:text-green-700 underline inline-block transition-colors" data-id="element-275">
                      Escribinos por WhatsApp y te ayudamos en minutos
                    </a>
                    <div className="pt-2 border-t border-slate-200 max-w-md mx-auto" data-id="element-276">
                      <p className="text-xs text-slate-500 leading-relaxed" data-id="element-277">
                        Producto digital – acceso inmediato.
                        <br data-id="element-278" />
                        El acceso se envía automáticamente por email luego del
                        pago.
                        <br data-id="element-279" />
                        No se envían productos físicos.
                      </p>
                    </div>
                  </div>

                  <p className="mt-4 text-sm text-slate-500" data-id="element-280">
                    🔒 Pago seguro • Descarga inmediata
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="mt-8 text-center" data-id="element-281">
              <p className="text-slate-600 italic" data-id="element-282">
                "Menos de lo que gastás en un café por día durante un mes...
                pero con resultados que duran todo el año"
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Transformation / Promise Section */}
      <section className="py-12 md:py-20 bg-gradient-to-b from-sky-50 to-white" data-id="element-283">
        <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-284">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="max-w-4xl mx-auto" data-id="element-285">
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-slate-900 mb-4 md:mb-8 leading-tight" data-id="element-286">
              Tu calma vale oro
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-slate-600 mb-8 md:mb-12 leading-relaxed" data-id="element-287">
              Este Mega Pack puede ahorrarte cientos de horas de búsqueda y
              adaptación durante el año... y devolverte algo que no tiene
              precio: <strong data-id="element-288">tu tranquilidad mental.</strong>
            </p>

            <div className="bg-white p-6 md:p-8 rounded-2xl md:rounded-3xl shadow-lg md:shadow-xl border border-sky-100 mb-8 md:mb-12" data-id="element-289">
              <h3 className="text-xl md:text-2xl font-bold text-slate-800 mb-4 md:mb-6" data-id="element-290">
                Empezá a enseñar con:
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-291">
                {['Más calma', 'Más seguridad', 'Más organización', 'Más disfrute'].map((item, i) => <div key={i} className="flex flex-col items-center p-3 md:p-4 bg-sky-50 rounded-xl" data-id="element-292">
                    <Sparkles className="w-5 h-5 md:w-6 md:h-6 text-sky-500 mb-1 md:mb-2" data-id="element-293" />
                    <span className="font-bold text-sm md:text-base text-slate-700 text-center" data-id="element-294">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>

            <div className="flex flex-col items-center gap-6 w-full" data-id="element-295">
              <CTAButton className="w-full sm:w-auto text-base md:text-xl px-6 md:px-12 py-4 md:py-5 shadow-xl md:shadow-2xl shadow-orange-200" href="https://checkout.tuvidasimple.shop/cart/44331468619878:1" data-id="element-296" />

              <div className="space-y-3" data-id="element-297">
                <div className="flex items-center justify-center gap-2 text-slate-700" data-id="element-298">
                  <MessageCircle className="w-5 h-5 text-green-500" data-id="element-299" />
                  <p className="text-sm font-medium" data-id="element-300">
                    💬 ¿Tuviste algún problema con el pago o con el acceso?
                  </p>
                </div>
                <a href="https://wa.link/w7hdgn" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-green-600 hover:text-green-700 underline inline-block transition-colors" data-id="element-301">
                  Escribinos por WhatsApp y te ayudamos en minutos
                </a>
                <div className="pt-2 border-t border-slate-200 max-w-md mx-auto" data-id="element-302">
                  <p className="text-xs text-slate-500 leading-relaxed" data-id="element-303">
                    Producto digital – acceso inmediato.
                    <br data-id="element-304" />
                    El acceso se envía automáticamente por email luego del pago.
                    <br data-id="element-305" />
                    No se envían productos físicos.
                  </p>
                </div>
              </div>

              <p className="text-sm text-slate-500" data-id="element-306">
                Acceso inmediato • Material digital • Descarga segura
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 md:py-20 bg-white" data-id="element-307">
        <div className="container mx-auto px-4 md:px-6" data-id="element-308">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8 md:mb-12" data-id="element-309">
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-slate-900 mb-3 md:mb-4 leading-tight" data-id="element-310">
              Lo que dicen las docentes
            </h2>
            <p className="text-lg md:text-xl text-slate-600" data-id="element-311">
              Más de 500 docentes ya están usando el Mega Pack
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-7xl mx-auto" data-id="element-312">
            <TestimonialCard name="María Fernández" city="Buenos Aires" comment="Este pack me salvó la vida. Ya no paso los domingos angustiada buscando ideas. Todo está súper organizado y listo para usar. Lo recomiendo 100%." delay={0} data-id="element-313" />
            <TestimonialCard name="Laura Gómez" city="Córdoba" comment="La mejor inversión que hice este año. Tengo recursos para todo el año y me sobra tiempo para mi familia. Las actividades son geniales y a los chicos les encantan." delay={0.1} data-id="element-314" />
            <TestimonialCard name="Sofía Martínez" city="Rosario" comment="No puedo creer todo lo que incluye por ese precio. Los bonus son increíbles, especialmente los moldes de goma eva. Ya lo compartí con todas mis compañeras." delay={0.2} data-id="element-315" />
            <TestimonialCard name="Carolina Rodríguez" city="Mendoza" comment="Llevo 15 años en nivel inicial y este es el recurso más completo que encontré. Me ahorra horas de planificación y las propuestas son súper creativas." delay={0.3} data-id="element-316" />
            <TestimonialCard name="Gabriela López" city="La Plata" comment="Estaba cansada de improvisar y sentir que no llegaba preparada. Con este pack tengo todo organizado y me siento mucho más segura en la sala." delay={0.4} data-id="element-317" />
            <TestimonialCard name="Valeria Sánchez" city="Tucumán" comment="Los audiocuentos y las efemérides argentinas son un tesoro. Mis alumnos están súper enganchados y yo recuperé mi tranquilidad. ¡Gracias!" delay={0.5} data-id="element-318" />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-300 py-12" data-id="element-319">
        <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-320">
          <div className="mb-8" data-id="element-321">
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-322">
              Mega Pack Nivel Inicial
            </h3>
            <p className="text-slate-400" data-id="element-323">
              Recursos hechos por docentes, para docentes.
            </p>
          </div>
          <div className="w-16 h-1 bg-slate-700 mx-auto mb-8 rounded-full" data-id="element-324"></div>
          <p className="font-medium text-lg text-white mb-8" data-id="element-325">@tuvidasimpleok</p>
          <div className="text-sm text-slate-500" data-id="element-326">
            &copy; {new Date().getFullYear()} Todos los derechos reservados.
          </div>
        </div>
      </footer>
    </div>;
}